import React from 'react';

interface ChatLinkErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

interface ChatLinkErrorBoundaryState {
  hasError: boolean;
}

export class ChatLinkErrorBoundary extends React.Component<
  ChatLinkErrorBoundaryProps,
  ChatLinkErrorBoundaryState
> {
  constructor(props: ChatLinkErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ChatLinkErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}
